<script setup>
import { computed, onMounted } from 'vue';
import { CsIcon } from '../icon';
import { useModalContext } from './useModal';

const { onClose, rootProps, hasModalHeader } = useModalContext();

const isShowCloseIcon = computed(() => rootProps.value?.isShowCloseIcon);

onMounted(() => {
  hasModalHeader.value = true;
});
</script>

<template>
  <div
    data-component="CsModalHeader"
    class="py-3 px-4 text-brand-text bg-brand-gray-5 dark:bg-brand-background border-b border-brand-gray-8 dark:border-brand-gray-15 flex items-center justify-between h-[45px]"
  >
    <div class="text-sm font-semibold text-brand-text">
      <slot />
    </div>

    <button
      v-if="isShowCloseIcon"
      class="absolute cursor-pointer top-2 right-2 h-7 w-7 rounded-lg text-brand-gray-12 hover:bg-brand-gray-8 dark:hover:bg-brand-background-secondary active:bg-brand-gray-9 transition-colors flex items-center justify-center"
      @click="onClose"
    >
      <CsIcon name="x" />
    </button>
  </div>
</template>
